'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('project-edit', {
      url: '/project/edit/:id',
      template: '<project-edit></project-edit>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/project/edit/project-edit.routes.js